exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".title-name{color:#ff3b30;font-size:16px;font-weight:700;padding-top:13px}h4{margin-bottom:0}.subtitle{font-size:14px;color:#9b9b9b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/title-time/time-title.scss
// module id = 839
// module chunks = 0